import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { Box } from "@mui/material";
import Navbar from "./components/Navbar";
import Dashboard from "./pages/Dashboard";
import ProjectDetail from "./pages/ProjectDetail";
import AddComponent from "./pages/AddComponent";
import ViewESS from "./pages/ViewESS";
import ImportProject from "./pages/ImportProject";
import SchematicBuilder from "./pages/SchematicBuilder";
import SchematicEditWrapper from "./pages/SchematicEditWrapper";
import SchematicViewer3D from "./pages/SchematicViewer3D";
import PasswordGate from "./components/PasswordGate";

function App() {
  return (
    <PasswordGate>
      <Box sx={{ backgroundColor: "#f0f2f5", minHeight: "100vh" }}>
        <Navbar />
        <Box
          sx={{
            maxWidth: "1400px",
            margin: "0 auto",
            padding: { xs: "1rem", sm: "1.5rem", md: "2rem" },
          }}
        >
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/create" element={<SchematicBuilder />} />
            <Route path="/import" element={<ImportProject />} />
            <Route path="/project/:id" element={<ProjectDetail />} />
            <Route
              path="/project/:id/add-component"
              element={<AddComponent />}
            />
            <Route path="/project/:id/3d" element={<SchematicViewer3D />} />
            <Route path="/view/:id" element={<ViewESS />} />
            <Route
              path="/schematic/edit/:id"
              element={<SchematicEditWrapper />}
            />
            {/* ── Catch-all — redirect unknown routes to dashboard ── */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Box>
      </Box>
    </PasswordGate>
  );
}

export default App;
